import getters from "./EtudeTechniqueGetters";
import actions from "./EtudeTechniqueActions";
import mutations from "./EtudeTechniqueMutations";

const state = {
    constructionsData: [],
    techInstallations: [],
    labourCard: [],
    tools: [],
    transportation: [],
    furnitureCard: [],
    techHardware: [],
    itmo: []
};

export default {
    state,
    getters,
    actions,
    mutations
};
